// src/project/data/triggers/updateLocation.js
import { buildActionUrl, RIDER_ENDPOINTS, getRiderId } from '../config/apiConfig'

/**
 * Action: Update Rider Location
 * POST: /rider/update/location/{riderId}
 */
export default {
  postUrl() {
    const riderId = getRiderId()
    if (!riderId) return null
    // Nouveau endpoint V3
    return buildActionUrl(RIDER_ENDPOINTS.UPDATE_LOCATION(riderId))
  },
  format(payload) {
    // V3 attend : { lat, lng }
    // Suppression de l'ancien userId du body et du renommage latitude/longitude → lat/lng
    return {
      lat: payload.lat ?? payload.latitude,
      lng: payload.lng ?? payload.longitude,
    }
  },
  parse(raw = {}) {
    // Réponse V3 attendue :
    // { statusCode: 200, message: "Location updated", data: { lat, lng, address, lastLocationUpdateDate } }
    return {
      success: raw?.statusCode === 200,
      data: raw?.data || null,
    }
  },
}
